import React from 'react';
import BeforeAfterSlider from './BeforeAfterSlider';

const Results = () => {
  const comparisons = [
    {
      title: 'Residential Front Windows',
      before: 'https://customer-assets.emergentagent.com/job_tech-raiders/artifacts/qu84gvpc_IMG_7730.png',
      after: 'https://customer-assets.emergentagent.com/job_tech-raiders/artifacts/hh41m2a8_IMG_7723.jpg'
    },
    {
      title: 'Patio Door Detail Clean',
      before: 'https://customer-assets.emergentagent.com/job_tech-raiders/artifacts/pys29nsn_IMG_7732.png',
      after: 'https://customer-assets.emergentagent.com/job_tech-raiders/artifacts/3luc227z_IMG_7721.jpg'
    },
    {
      title: 'Complete Home Exterior',
      before: 'https://customer-assets.emergentagent.com/job_tech-raiders/artifacts/365tcs6h_IMG_7736.png',
      after: 'https://customer-assets.emergentagent.com/job_tech-raiders/artifacts/g23hdpjh_IMG_7726.jpg'
    }
  ];

  return (
    <section id="results" className="py-24 bg-gradient-to-b from-black to-zinc-950">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="font-['Bebas_Neue'] text-6xl md:text-7xl text-white mb-4">
            SEE THE <span className="text-[#CC0000]">DIFFERENCE</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Drag the slider to compare before and after results. These are real windows we've cleaned across Lubbock.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {comparisons.map((comparison, index) => (
            <BeforeAfterSlider
              key={index}
              title={comparison.title}
              beforeImage={comparison.before}
              afterImage={comparison.after}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Results;
